import React, { useState, Fragment } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import millimeterMask from "Components/Input/components/millimeterMask";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import showNotify from "Helpers/Notify";
import { GetAllTori, putEditTori } from "Stores/actions";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

function EditTori({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { toriDataPagination } = useSelector((state) => ({
    toriDataPagination: state.tori.toriDataPagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [loading, setLoading] = useState(false);

  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.Name,
      row: 1,
      auth: true,
      validation: {
        required: true,
      },
      col: {
        xs: 12,
        sm: 6,
      }
    },
    groupPrice: {
      type: "price",
      value: row.GroupPrice,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
        notZero: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
      auth: read("StypeU") === "1",
    },
    userPrice: {
      type: "price",
      value: row.UserPrice,
      row: 1,
      validation: {
        required: true,
        isPrice: true,
        notZero: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
      auth: read("StypeU") === "2" || read("StypeU") === "5",
    },
    incW: {
      type: "millimeter",
      value: row.IncW,
      row: 2,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        notZero: true,
        allowMinus: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    incH: {
      type: "millimeter",
      value: row.IncH,
      row: 2,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        notZero: true,
        allowMinus: true
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    MovableInc: {
      type: "millimeter",
      value: "",
      row: 3,
      validation: {
        required: true,
        isNumeric: true,
        notZero: true,
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
    MovableCount: {
      type: "number",
      value: "",
      row: 3,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
        max: 2,
      },
      col: {
        xs: 12,
        sm: 6,
      },
    },
  })

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  }

  const handleDialog = () => {
    setShowDialog(!showDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(change) {
      const { name, groupPrice, userPrice, incW, incH, MovableInc, MovableCount } = controls;
      if (
        !R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)
      ) {
        let price;
        if (groupPrice.auth) {
          price = +groupPrice.value;
        } else {
          price = +userPrice.value;
        }
        try {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Price: price,
            Id: +row.Id,
            Name: name.value,
            incW: +incW.value,
            incH: +incH.value,
            movableInc: MovableInc.value,
            movableCount: MovableCount.value,
          };
          await dispatch(putEditTori(data));
          handleDialog();
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Limit: toriDataPagination.Limit,
            Page: toriDataPagination.Page,
          };
          await dispatch(GetAllTori(params));
          onClear();
        } catch (e) {
          showNotify({
            text: t('correctFormDataRequired'),
            customClass: "error",
          });
        }
        handleDialog();
      } else if (R.isEmpty(formValid)) {
        handleDialog();
      } else {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
    } else {
      handleDialog();
      // showNotify({
      //   text: t('noEditedItem'),
      //   customClass: "warning",
      // });
    }
    setLoading(false);
  };

  const onEnter = async () => {
    onClear();
  };

  const onClear = () => {
    setFormValid({});
    setControls({ name: { value: row.Name } });
    setControls({ incW: { value: row.IncW } });
    setControls({ incH: { value: row.IncH } });
    setControls({ MovableInc: { value: row.MovableInc } });
    setControls({ MovableCount: { value: row.MovableCount } });
    setControls({ groupPrice: { value: convertToEnglishNumber(row.GroupPrice.replaceAll(',','')) } });
    setControls({ userPrice: { value: convertToEnglishNumber(row.UserPrice.replaceAll(',','')) } });
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
          (row.IsG &&
              read("StypeU") !== "1") ||
          read("toriRules")?.accessUpdate === false ||
          row.Disable
        }
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p><Translator id="virayesh_tori" /></p>
          </div>
          <DialogContent style={{ overflow: "visible" }}>
            <Grid container spacing={2} className="mb-1 d-flex">
              {
                Object.keys(controls).filter(key => controls[key].row === 1).filter(key => controls[key].auth).map((key, index) => {
                  return (
                    <Grid item className="flex-grow-1" key={key + index}>
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        endIcon={controls[key].type === "price" ? <Translator id='moneyUnit' /> : ''}
                      />
                    </Grid>
                  );
                })
              }
            </Grid>
            <Grid container>
              <Grid item xs={12} className="text-center py-2 mb-3" style={{backgroundColor: '#E4E8E8'}}>
                <strong><Translator id="netIncWH" noSpan/></strong>
              </Grid>
              <Grid container spacing={2}>
                {
                  Object.keys(controls).filter(key => controls[key].row === 2).map((key, index) => {
                    return (
                      <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          endIcon={<Translator id='millimeter' />}
                          minLength={controls[key]?.validation?.minLength}
                          maxlength={controls[key]?.validation?.maxLength}
                          inputComponent={millimeterMask}
                        />
                      </Grid>
                    );
                  })
                }
              </Grid>
              <Grid item xs={12} className="text-center py-2 mb-3" style={{backgroundColor: '#E4E8E8'}}>
                <strong><Translator id="netMovable" noSpan/></strong>
              </Grid>
              <Grid container spacing={2}>
                {
                  Object.keys(controls).filter(key => controls[key].row === 3).map((key, index) => {
                    return (
                      <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          endIcon={controls[key].type === "millimeter" ? <Translator id='millimeter' /> : ''}
                          inputComponent={controls[key].type === "millimeter" && millimeterMask}
                        />
                      </Grid>
                    );
                  })
                }
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default EditTori;
